import React from "react";

const TrendUpGreen = ({ color = "#22C55E", style }: { color?: string; style?: React.CSSProperties }) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={style}
        >
            <path d="M2 11.3334L6 7.33335L8.66667 10L14 4.66669" fill="none"/>
            <path d="M2 11.3334L6 7.33335L8.66667 10L14 4.66669" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M11.3335 4.66669H14.0002V7.33335" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
};

export default TrendUpGreen;
